/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthPlatformRemotePatient } from './PalAuthPlatformRemotePatient';
import {
    PalAuthPlatformRemotePatientFromJSON,
    PalAuthPlatformRemotePatientFromJSONTyped,
    PalAuthPlatformRemotePatientToJSON,
} from './PalAuthPlatformRemotePatient';

/**
 * 
 * @export
 * @interface SearchPalAuthPlatformRemotePatient200Response
 */
export interface SearchPalAuthPlatformRemotePatient200Response {
    /**
     * 
     * @type {Array<PalAuthPlatformRemotePatient>}
     * @memberof SearchPalAuthPlatformRemotePatient200Response
     */
    data?: Array<PalAuthPlatformRemotePatient>;
}

/**
 * Check if a given object implements the SearchPalAuthPlatformRemotePatient200Response interface.
 */
export function instanceOfSearchPalAuthPlatformRemotePatient200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchPalAuthPlatformRemotePatient200ResponseFromJSON(json: any): SearchPalAuthPlatformRemotePatient200Response {
    return SearchPalAuthPlatformRemotePatient200ResponseFromJSONTyped(json, false);
}

export function SearchPalAuthPlatformRemotePatient200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPalAuthPlatformRemotePatient200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(PalAuthPlatformRemotePatientFromJSON)),
    };
}

export function SearchPalAuthPlatformRemotePatient200ResponseToJSON(value?: SearchPalAuthPlatformRemotePatient200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(PalAuthPlatformRemotePatientToJSON)),
    };
}

